import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import 'rxjs/Rx';

// Route module
import { AppRoutingModule } from './app.routing.module';

// Components
// import { AppComponent } from './app.component';

// Services - imported here because it needs to be loaded in the root injector
import { PhoneService } from './fonzi-module/services';

// Fonzi module
import { FonziModule } from './fonzi-module/fonzi.module';
import { FonziComponent } from './fonzi-module/fonzi.component';

@NgModule({
  declarations: [
    // AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FonziModule
  ],
  providers: [
    PhoneService
  ],
  bootstrap: [FonziComponent]
  // bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts